import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslatePipe } from '../../pipes/translate.pipe';

export type ConfirmDialogResponse = boolean;

interface OptionalParams {
	yesLabel?: string;
	noLabel?: string;
	title?: string;
	translate?: boolean | {
		message?: boolean;
		yesLabel?: boolean;
		noLabel?: boolean;
		title?: boolean;
	};
	yesColor?: ThemePalette;
	noColor?: ThemePalette;
}
export interface QuantityScanDialogParams extends OptionalParams {
	message: string | string[];
}
export interface DialogData {
  animal: string;
  name: string;
  saveAsNew: boolean;
  repeat: boolean;
  repeatUnit: string;
  repeatCount: number;
  repeatMax: number;
  repeatOrNew: string;
  Quantity: string;
  Remove: boolean;
}
@Component({
	selector: 'app-quantity-scan',
	templateUrl: './quantity-scan.component.html',
	styleUrls: ['./quantity-scan.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuantityScanDialogComponent  {
	constructor(
    public dialogRef: MatDialogRef<QuantityScanDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}
